import { render, staticRenderFns } from "./m-modal-terms-and-conditions.vue?vue&type=template&id=7596f524&scoped=true&"
import script from "./m-modal-terms-and-conditions.vue?vue&type=script&lang=js&"
export * from "./m-modal-terms-and-conditions.vue?vue&type=script&lang=js&"
import style0 from "./m-modal-terms-and-conditions.vue?vue&type=style&index=0&id=7596f524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596f524",
  null
  
)

export default component.exports